import { useRef, useEffect, useContext } from "react";
import BlockchainContext from "../store/BlockchainContext";
import { walletAddressSlicer } from "../utils/util";

const DisconnectModalBox = ({ handleClose }) => {
  const modalRef1 = useRef(null);
  const ModalContainerRef1 = useRef(null);
  const { account, handleDisconnectWallet } = useContext(BlockchainContext);
  const handleClickOutside = (event) => {
    if (
      ModalContainerRef1.current &&
      !modalRef1.current.contains(event.target)
    ) {
      handleClose();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDisWallet = () => {
    handleDisconnectWallet();
    handleClose();
  };
  return (
    <div className="modalContainer" id="mdcon" ref={ModalContainerRef1}>
      <div className="modal-exit" ref={modalRef1}>
        <h4>Wallet Details</h4>
        <button
          type="button"
          className="fancybox-button fancybox-close-small"
          onClick={() => handleClose()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1"
            viewBox="0 0 24 24"
          >
            <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path>
          </svg>
        </button>
        <div className="modal-exit__wrap">
          <div className="col">
            <h5>Account</h5>

            <div className="modal-exit__wallet">
              <div className="modal-exit__icon">
                <img src="/assets/img/icons/logo.svg" alt="MATIC Daily" />
              </div>
              <h4>{walletAddressSlicer(account)}</h4>
            </div>
          </div>

          <button className="button" onClick={handleDisWallet}>
            <span>
              <img src="/assets/img/icons/switch.svg" alt="MATIC Daily" />
              Disconnect
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisconnectModalBox;
